import { useState } from 'react';
import { API } from '@/lib/apiConfig';
import LoadingSpinner from '../components/common/LoadingSpinner';
import ErrorBanner from '../components/common/ErrorBanner';

export function TenderScoring() {
  const [companyId, setCompanyId] = useState('demo');
  const [certs, setCerts] = useState('1,2,3');
  const [taxonomy, setTaxonomy] = useState(70);
  const [supplier, setSupplier] = useState(65);
  const [result, setResult] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const score = async () => {
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const body = { companyId, certificateIds: certs.split(',').map(s=>s.trim()).filter(Boolean), taxonomyScore: taxonomy, supplierScore: supplier };
      const res = await fetch(API.tender + '/tender/score', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      
      if (!res.ok) {
        throw new Error(`HTTP ${res.status}: ${res.statusText}`);
      }
      
      const data = await res.json();
      setResult(data);
    } catch (e) {
      const error = e instanceof Error ? e : new Error('Failed to score tender');
      setError(error);
      console.error('Tender scoring failed:', e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-3">
      <div className="font-orbitron text-evat-gold">Tender Auto-Scoring</div>
      <div className="text-xs text-yellow-400">TENDER SCORE PRE-EVALUATION ONLY</div>
      
      <ErrorBanner error={error} onRetry={score} showRetry={!!error} />
      
      {loading && <LoadingSpinner size="sm" text="Scoring tender..." />}
      
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-2 text-sm">
        <input
          value={companyId}
          onChange={(e)=>setCompanyId(e.target.value)}
          disabled={loading}
          className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1 disabled:opacity-50"
          placeholder="Company ID"
        />
        <input
          value={certs}
          onChange={(e)=>setCerts(e.target.value)}
          disabled={loading}
          className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1 disabled:opacity-50"
          placeholder="Certificates (csv)"
        />
        <input
          type="number"
          value={taxonomy}
          onChange={(e)=>setTaxonomy(Number(e.target.value))}
          disabled={loading}
          className="bg-black border border-evat-gold text-evat-gold rounded px-2 py-1 disabled:opacity-50"
          placeholder="Taxonomy"
        />
        <input
          type="number"
          value={supplier}
          onChange={(e)=>setSupplier(Number(e.target.value))}
          disabled={loading}
          className="bg-black border border-evat-gold text-evat-gold rounded px-2 py-1 disabled:opacity-50"
          placeholder="Supplier"
        />
      </div>
      <button
        onClick={score}
        disabled={loading}
        className="px-3 py-1 rounded border border-evat-neon text-evat-neon hover:shadow-neon disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {loading ? 'Scoring...' : 'Score'}
      </button>
      {result && !loading && (
        <pre className="text-xs bg-black border border-neutral-700 rounded p-3 overflow-auto max-h-64">{JSON.stringify(result, null, 2)}</pre>
      )}
    </div>
  );
}

export default TenderScoring;














